import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VBtn,
    {
      staticClass: "bg-gray-0 elevation-1",
      attrs: {
        "data-qa": "delete_btn",
        color: "icon-secondary",
        height: "24",
        width: "24",
        icon: "",
      },
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [_c("span", { staticClass: "ui-icon-trash ui-icon-fz-smaller" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }